interface IGetFormValuesObjOps {
  dateForWebservice?: boolean;
}

export type IGetFormValuesObj = (
  $form: JQuery<HTMLFormElement> | string,
  options?: IGetFormValuesObjOps
) => IDCA.IGenericObj;

export function getFormValuesObj(
  $form: JQuery<HTMLFormElement> | string,
  options: IGetFormValuesObjOps = {}
): IDCA.IGenericObj {
  const { dateForWebservice } = options;

  const values: IDCA.IGenericObj = {};
  const cleanValues: IDCA.IGenericObj = {};
  const serialized = typeof $form === 'string' ? $form : $form.serialize();
  const serializeArr = serialized.split('&');

  // Create object of current field names and values
  for (const val of serializeArr) {
    const valArr = val.split('=');
    const k = valArr[0];
    const v = valArr[1];
    let newValue: string | string[] = v;

    // Key already has value, keep old and add new in array
    if (values[k]) {
      newValue = Array.isArray(values[k]) ? [...values[k], v] : [values[k], v];
    }

    values[k] = newValue;
  }

  const suffix = Object.hasOwnProperty.call(values, 'fieldSuffix') ? values.fieldSuffix : '';

  // Clean up values
  Object.keys(values).forEach((key) => {
    const fieldId = key.replace('field_', '').replace(suffix, '');

    const field = window.DexeroCoreApp.getFieldProperties(String(fieldId), suffix);
    let fieldIdentifier = fieldId;
    let val = values[key];
    if (field) {
      fieldIdentifier = field.identifier;
      if (field.type === 4 && dateForWebservice) {
        const $field = $(`[name="${key}"]`);
        const datepicker = $field.data('datepicker');
        if (datepicker) {
          val = datepicker.getMomentOfValue().format('YYYYMMDDHHmmss');
        }
      }
      if (field.type === 0 && dateForWebservice) {
        val = window.DexeroCoreApp.escapeJSON(val);
      }
    }

    cleanValues[fieldIdentifier] = val;
  });

  return cleanValues;
}
